import { createNumberAriaLabel } from 'helpers/accessibility/ariaLabelHelpers';
import useTranslation from 'next-translate/useTranslation';
import twMerge from 'utils/twMerge';

type ProductInfoProps = {
    catalogNumber: string;
    quantity: number;
    className?: string;
};

export const ProductInfo: FC<ProductInfoProps> = ({ catalogNumber, quantity, className }) => {
    const { t } = useTranslation();

    return (
        <div className={twMerge('flex hidden w-full items-center justify-start vl:block', className)}>
            <div className="flex flex-col">
                <div className="text-h6 font-bold">{t('{{ count }} pcs', { count: quantity })}</div>
                <div aria-label={`${t('Product code')} ${createNumberAriaLabel(catalogNumber)}`} className="text-small">
                    {t('Product code')} {catalogNumber}
                </div>
            </div>
        </div>
    );
};
